import { Box } from '@mui/material'
import React from 'react'

const DeleteModal = () => {
    return (
        // <Box sx={{ my: 3 }}>Are you sure you want to delete this league?</Box>
        <Box sx={{ my: 3 }}>Are you sure, you want to Delete ?</Box>
    )
}

export default DeleteModal